import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';

/**
 * Generated class for the PopoverSettingsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popover-settings',
  templateUrl: 'popover-settings.html',
})
export class PopoverSettingComponent {

  variableheight:string;

  constructor(public navCtrl: NavController, public navParams: NavParams,public events: Events) {

    this.variableheight = this.navParams.get("imgsize");
  }

  ionViewDidLoad() {
   // console.log('ionViewDidLoad PopoverSettingsPage');


  }


  changeImgSize() {

    console.log(this.variableheight);
    this.events.publish('settings:imgsize',this.variableheight );
  //  localStorage.setItem("Settings", this.variableheight);

  }


}



// WEBPACK FOOTER //
// ./src/components/popover-settings/popover-settings.ts